export default {
  getReportDataGetter: state => {
    return state.reportData;
  },
  getReportTotalCount: state => {
    return state.reportTotalCount;
  },
  hasNextPage: state => {
    if (state.pageInfo !== null)
    {
      return state.pageInfo.hasNextPage;
    }

    return false;
  },
  hasPreviousPage: state => {
    if (state.pageInfo !== null)
    {
      return state.pageInfo.hasPreviousPage;
    }

    return false;
  },
  getPageInfoNextCursor: state => {
    if (state.pageInfo !== null)
    {
      return state.pageInfo.endCursor;
    }
  },
  getPageInfoPreviousCursor: state => {
    if (state.pageInfo !== null)
    {
      return state.pageInfo.startCursor;
    }
  },
  getFixedColumns: state => {
    return state.fixedColumns;
  },
  getReportChartsData: state => {
    return state.reportChartsData;
  },
  getSummaryReportChartsData: state => {
    return state.summaryChartsData;
  },
  getCurrentRowsCount: state => {
    return state.currentRowsCount;
  },
  getReportSummaryData: state => {
    return state.reportSummaryData;
  },

  getDateComparisonFields: state => {
    return state.dateComparisonFields;
  },
  getSortColumn: state => {
    return state.sortColumn;
  },
  getSortDirection: state => {
    return state.sortDirection;
  },
  getHoverStatuses: state => {
    return state.hoverStatuses;
  },
  getSideBarStatus: state => {
    return state.sideBarStatus;
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/baseReport/table/getters.js